import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import logo from '../../assets/pacego.png';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* 品牌信息 */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={logo} 
                alt="跑伴Logo" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <div className="text-lg font-bold">跑伴</div>
                <div className="text-xs text-gray-400">RunBuddy</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              专业陪跑服务平台，让每一次奔跑都有专业陪伴
            </p>
          </div>

          {/* 快速链接 */}
          <div>
            <h3 className="font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/" className="hover:text-orange-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-orange-500 transition-colors">
                  产品介绍
                </Link>
              </li>
              <li>
                <Link to="/investor" className="hover:text-orange-500 transition-colors">
                  投资人演示
                </Link>
              </li>
              <li>
                <Link to="/portal" className="hover:text-orange-500 transition-colors">
                  系统入口
                </Link>
              </li>
            </ul>
          </div>

          {/* 服务项目 */}
          <div>
            <h3 className="font-semibold mb-4">服务项目</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>专业陪跑服务</li>
              <li>配速指导培训</li>
              <li>心理支持辅导</li>
              <li>赛事报名协助</li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h3 className="font-semibold mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span>contact@runbuddy.cn</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span>北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© 2024 RunBuddy 跑伴. 让每一次奔跑都有专业陪伴.</p>
          <p className="mt-2">
            <a href="https://runbuddy.ehinfo.com.cn" className="hover:text-orange-500 transition-colors">
              runbuddy.ehinfo.com.cn
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
